import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.9998 1H14.4805L13.245 5.22222H10.3406C9.88411 3.39335 8.20414 2.05566 6.23139 2.05566C3.91363 2.05566 2 3.90217 2 6.22233C2 8.23985 3.47483 9.86381 5.34902 10.2782L6.2174 23H18.8567L20.0704 5.22222H15.3289L15.9791 3H19.9998V1ZM7.38113 10.7041L7.14471 7.22233L12.6597 7.22222L11.4475 11.365L7.38113 10.7041ZM17.9292 7.22222L17.5771 12.3794L13.4357 11.692L14.7436 7.22222H17.9292Z"}}]};

const DrinkFilled = Vue.extend<IconProps>({
  name: 'DrinkFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'drink-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DrinkFilled;
